import { clone, forEach, forOwn, get, isEmpty, isEqual, set } from 'lodash'
import { formatMoney } from 'accounting'
import moment from 'moment'
import { saveAs } from 'file-saver'

import Authentication from './Authentication'

// export default {
export async function handleErrors(response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    if (!new Authentication().isAuthenticated()) {
      window.location = '#/login'
      throw await response.json()
    }
    throw await response.json()
  }
}

export async function handleResponse(response) {
  return await response.json()
}

export async function handleFileResponse(response) {
  return await response.blob().then((blob) => {
    saveAs(blob, 'salary.csv')
    return blob
  })
}

export function strVal(object, path, defaultString = '') {
  const value = get(object, path)
  if (Number.isFinite(value)) return value.toString()
  if (isEmpty(value)) return defaultString
  if (typeof value === 'string' || value instanceof String) {
    return value
  } else {
    return JSON.stringify(value)
  }
}

// to allow updating form attributes with empty
export function normalizeNull(v) {
  return v === undefined || v === '' ? null : v
}

export function normalizeDateTimeToDate(object, path, returnValue) {
  if (returnValue === true) {
    let newObject = Object.assign({}, object)
    let value = get(newObject, path)
    if (value) value = value.format('YYYY-MM-DD')
    return value
  }
  get(object, path) && set(object, path, get(object, path).format('YYYY-MM-DD'))
}

export function numVal(object, path) {
  return isNumeric(get(object, path)) ? Number(get(object, path)) || 0 : 0
}

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n)
}

export function arrVal(object, path) {
  return get(object, path) || []
}

export function boolVal(object, path) {
  return Boolean(get(object, path)) || false
}

export function dateVal(object, path, def) {
  try {
    return get(object, path) ? moment(get(object, path), def) : undefined
  } catch (e) {
    console.error(e)
    return undefined
  }
}

export function moneyInline(value, currency) {
  return formatMoney(value, {
    symbol: currency || '',
    format: '%v %s',
  })
}

export function moneyColumn(value) {
  return formatMoney(value, ``)
}

export function dateFormat(date, format = 'DD MMM YYYY') {
  return date && date.format(format)
}

export function dateMonthFormat(date) {
  return date && date.format('MMM YYYY')
}

export function timeFormat(date) {
  return date && date.format('HH:mm')
}

export function timeDateFormat(date) {
  return date && date.format('DD MMM YYYY HH:mm:ss')
}

export function getOrdinal(n) {
  const s = ['th', 'st', 'nd', 'rd'],
    v = n % 100
  return n + (s[(v - 20) % 10] || s[v] || s[0])
}

export function shallowCompare(instance, nextProps, nextState) {
  return !isEqual(instance.props, nextProps) || !isEqual(instance.state, nextState)
}

export async function execute(instance, _func, message) {
  try {
    instance.setState({ fetching: true })
    await _func()
    message.success('Success')
    return true
  } catch (error) {
    instance.setState({ fetching: false })
    message.error(error.errorMessage)
    throw error
  }
}

export function getLabel(address) {
  function newLine() {
    return ' \n '
  }

  function space() {
    return ' '
  }

  return (
    strVal(address, 'address') +
    (strVal(address, 'address') !== '' ? newLine() : '') +
    strVal(address, 'street') +
    space() +
    strVal(address, 'city') +
    space() +
    strVal(address, 'state') +
    newLine() +
    strVal(address, 'country') +
    newLine() +
    strVal(address, 'postcode')
  )
}

export function sessionItemSub(sessionKey, name, key) {
  return (
    get(
      (get(JSON.parse(sessionStorage.getItem(sessionKey) || '{}'), name) || []).find((u) => key === u.key),
      'value'
    ) || ''
  )
}

export function sessionItemVal(sessionKey, key) {
  return (
    get(
      JSON.parse(sessionStorage.getItem(sessionKey) || '[]').find((u) => key === u.key),
      'value'
    ) || ''
  )
}

export function isSessionItemEmpty(sessionKey) {
  return isEmpty(JSON.parse(sessionStorage.getItem(sessionKey)))
}

export const sessionItem = (sessionKey, key, keyAttr = 'key') =>
  JSON.parse(sessionStorage.getItem(sessionKey) || '[]').find((u) => key === u[keyAttr])

export function sessionItemByKeys(sessionKey, key, keyAttr, valueAttr) {
  return (
    get(
      JSON.parse(sessionStorage.getItem(sessionKey) || '[]').find((u) => key === u[keyAttr]),
      valueAttr
    ) || ''
  )
}

export function sessionItemByCode(sessionKey, key) {
  return (
    get(
      JSON.parse(sessionStorage.getItem(sessionKey) || '[]').find((u) => key === u.code),
      'name'
    ) || ''
  )
}

export function* idMaker(index = 0) {
  while (index < index + 1) yield (index++).toString()
}

export function mapToKeys(object = {}, oldKeys = [], newKeys = []) {
  const newObject = {}
  forEach(oldKeys, function (value, key) {
    set(newObject, newKeys[key], get(object, value))
  })
  return newObject
}

export function unflatten(data = [], idAttr = '_id', parentAttr = '_parent', childrenAttr = 'children') {
  const arr = clone([...data])
  let indexKey = 0
  let tree = [],
    indexedObj = {}
  forEach(arr, (arrElem) => {
    arrElem.category = arrElem.category ? arrElem.category : 'N/A'
    arrElem.category = arrElem.category ? arrElem.category : 'N/A'
    return (indexedObj[arrElem[idAttr]] = arrElem)
  })
  forOwn(indexedObj, (mappedElem) => {
    mappedElem.rand_key = indexKey
    ++indexKey
    if (get(indexedObj, mappedElem[parentAttr])) {
      isEmpty(get(indexedObj, [mappedElem[parentAttr], childrenAttr])) &&
        set(indexedObj[mappedElem[parentAttr]], childrenAttr, [])
      indexedObj[mappedElem[parentAttr]][childrenAttr].push(mappedElem)
    } else {
      tree.push(mappedElem)
    }
  })
  return tree
}

export function filterCheckedColumns(filter, row) {
  if (filter.value === 'all') {
    return true
  }

  return filter.value === true ? row[filter.id] === true : row[filter.id] !== true
}

export function formatQueryParams(name, value, isFirst) {
  return value ? `${isFirst ? '?' : '&'}${name}=${value || ''}` : ''
}

export function checkForm(formRef) {
  return new Promise((res, rej) => {
    formRef.current.validateFieldsAndScroll((err, values) => {
      if (!err) {
        res(values)
      }
    })
  })
}

export function titleCase(str) {
  return str
    .toLowerCase()
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ')
}

export function replaceAll(target, search, replacement) {
  return target.replace(new RegExp(search, 'g'), replacement)
}

export function findCascadersParents(list, id, depthSlice = 0) {
  if (isEmpty(list)) return []

  let result = []

  function fp(ID) {
    let s = list.find((o) => o._id === ID)
    if (get(s, '_parent', false)) {
      result.unshift(s._parent)
      fp(s._parent)
    }
  }

  fp(id)
  if (depthSlice) result.splice(0, depthSlice)
  result.push(id)

  return result
}
